import { PremiumFolderType } from '../types/gallection';
import { PapiPremiumFolderData, PapiSellerDiscount } from '@wix/da-papi-types';
import { formatDollars } from './formatting';

export type NormalizedPremiumFolderDataProps = {
  isPremium: boolean;
  isPremiumLocked: boolean;
  isPaidFolder: boolean;
  isWatchToAccess: boolean;
  isDiscountApplied: boolean;
  dollarPrice?: number;
  dollarPriceAfterDiscount?: number;
  formattedDollarPrice: string;
  formattedDollarPriceAfterDiscount: string;
  pointPrice?: number;
  folderId?: number;
  folderUrl?: string;
  numSubscribers?: number;
  subproductId?: number;
  eligibleDiscount?: PapiSellerDiscount;
  notEligibleDiscounts?: PapiSellerDiscount[];
};

export function normalizePremiumFolderData(
  premiumFolderData?: PapiPremiumFolderData & {
    eligibleDiscount?: PapiSellerDiscount;
    notEligibleDiscounts?: PapiSellerDiscount[];
  }
): NormalizedPremiumFolderDataProps {
  const isPremiumContent = !!premiumFolderData;
  const dollarPrice = premiumFolderData?.dollarPrice;
  const formattedDollarPrice = formatDollars(dollarPrice);

  // Calculate price after discount
  let dollarPriceAfterDiscount = dollarPrice;
  const amount = premiumFolderData?.eligibleDiscount?.amount;
  if (amount) {
    if (amount.usd && dollarPrice) {
      dollarPriceAfterDiscount = dollarPrice - amount.usd;
    } else if (amount.percent && dollarPrice) {
      dollarPriceAfterDiscount = dollarPrice - (dollarPrice * amount.percent) / 100;
    }
  }
  const formattedDollarPriceAfterDiscount = formatDollars(dollarPriceAfterDiscount);

  return {
    isPremium: isPremiumContent,
    isPremiumLocked: isPremiumContent && !premiumFolderData?.hasAccess,
    isPaidFolder: isPremiumContent && premiumFolderData?.type === PremiumFolderType.Paid,
    isWatchToAccess: isPremiumContent && premiumFolderData?.type === PremiumFolderType.Watchers,
    isDiscountApplied: !!premiumFolderData?.eligibleDiscount,
    pointPrice: premiumFolderData?.pointsPrice,
    dollarPrice,
    dollarPriceAfterDiscount,
    formattedDollarPrice,
    formattedDollarPriceAfterDiscount,
    folderId: premiumFolderData?.galleryId,
    folderUrl: premiumFolderData?.galleryUrl,
    numSubscribers: premiumFolderData?.numSubscribers,
    subproductId: premiumFolderData?.subproductId,
    eligibleDiscount: premiumFolderData?.eligibleDiscount,
    notEligibleDiscounts: premiumFolderData?.notEligibleDiscounts,
  };
}
